import { insertIntercomMetadata } from '@/plugins/intercom';
import { insertLogRocketMetadata } from '@/plugins/logrocket';
import { insertRolloutMetadata } from '@/plugins/rollout';
import { insertAnalyticsMetadata } from '@/plugins/analytics';

export function insertPluginMetadata({
  user,
  activeCompany
}) {
  if (!user || !activeCompany) {
    console.error('User OR Company not found, we could not set metadata plugins');
    return false;
  }
  /**
   * Intercom
   */
  insertIntercomMetadata({
    email: user.email,
    user_hash: user.intercomHash,
    userId: user.id
  });

  /**
   * LogRocket
   */
  insertLogRocketMetadata({
    email: user.email,
    name: user.name,
    id: user.id,
    user_group: activeCompany.name,
    user_group_id: activeCompany.id
  });

  /**
   * Rollout
   */
  insertRolloutMetadata({
    user_email: user.email,
    user_name: user.name,
    user_id: user.id,
    user_group: activeCompany.name,
    user_group_id: activeCompany.id
  });

  /**
   * Analytic
   */
  insertAnalyticsMetadata({
    user_email: user.email,
    user_name: user.name,
    user_id: user.id,
    user_group: activeCompany.name,
    user_group_id: activeCompany.id
  });
}
